<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const recruitmentNeedOptions = [
        `Recrutement en CDI`,
        `Recrutement en CDD`,
        `Intérim / travail temporaire`,
        `Externalisation RH complète`,
        `Conseil RH ponctuel`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const positionCountOptions = [
        `1 poste`,
        `2 à 5 postes`,
        `6 à 10 postes`,
        `Plus de 10 postes`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const profileLevelOptions = [
        `Ouvriers / employés`,
        `Techniciens / agents de maîtrise`,
        `Cadres`,
        `Cadres supérieurs / dirigeants`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.agencesRecrutement.recruitmentNeed}
        class=""
        let:field
        let:id
        label={`Quel type de besoin en recrutement avez-vous actuellement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={recruitmentNeedOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agencesRecrutement.positionCount}
        class=""
        let:field
        let:id
        label={`Combien de postes souhaitez-vous pourvoir ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={positionCountOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agencesRecrutement.profileLevel}
        class=""
        let:field
        let:id
        label={`Quel niveau de profil recherchez-vous principalement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={profileLevelOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
